export default __webpack_public_path__ + "static/media/Avatar-7-noback.2f9f23ad.png";